import React, { useState, useEffect, useRef } from 'react'
import { makeStyles } from '@material-ui/core/styles';
import { useDispatch, useSelector } from 'react-redux';
import EmpowerActions from 'stores/leadbest-official-website/empower/actions'
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import Skeleton from '@material-ui/lab/Skeleton';
import moment from 'moment'
import languages from 'locales';
import ArrowBottom from './../../assets/images/arrow-bottom.png'
import Mascot from './../../assets/images/mascot.png'
import MascotBlack from './../../assets/images/mascot-black.png'
import ThirdBG from './../../assets/images/empower/third-background.png'
import ForthBG from './../../assets/images/empower/forth-background.jpg'
import Magnifier from './../../assets/images/Magnifier.png'
import Slider from "react-slick";
import rectangleGolden from './../../assets/images/rectangle-golden.png'
import rectangleGray from './../../assets/images/rectangle-gray.png'
import { injectIntl } from 'react-intl';
import { useHistory, Link } from "react-router-dom";
import clsx from 'clsx'
import { Helmet } from "react-helmet-async";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, EffectCreative } from 'swiper';
import 'swiper/swiper-bundle.min.css';

import LightGallery from 'lightgallery/react';

// import styles
import 'lightgallery/css/lightgallery.css';
import 'lightgallery/css/lg-zoom.css';
import 'lightgallery/css/lg-thumbnail.css';

// If you want you can use SCSS instead of css
import 'lightgallery/scss/lightgallery.scss';
import 'lightgallery/scss/lg-zoom.scss';

// import plugins if you need
import lgThumbnail from 'lightgallery/plugins/thumbnail';
import lgZoom from 'lightgallery/plugins/zoom';

const useStyles = makeStyles((theme) => ({
    root: {
    },
    firstBlock: {
        position: "relative",
        height: "100vh",
        backgroundSize: "cover",
        backgroundPosition: "center",
        color: "#fff",
        padding: "0px 24px",
        // "&:before": {
        //     content: "''",
        //     display: "block",
        //     width: "100%",
        //     height: "100%",
        //     position: "absolute",
        //     top: "0px",
        //     left: "0px",
        //     background: "rgba(0,23,51,0.5)"
        // },
        "& .time": {
            fontSize: "14px",
            color: "rgba(255,255,255,0.6)",
            paddingTop: "30vh",
            margin: "0px auto 12px auto",
            width: "fit-content",
            [theme.breakpoints.down('xs')]: {
                paddingTop: "15vh",
            }
        },
        "& .title": {
            textAlign: "center",
            fontSize: "28px",
            color: "#f5f5f5",
            fontWeight: "bold",
            margin: "0px auto 36px auto",
            width: "fit-content",
            [theme.breakpoints.down('xs')]: {
                fontSize: "24px",
                margin: "0px auto 24px auto",
                "&.en": {
                    fontSize: "20px",
                }
            }
        },
        "& .divider": {
            width: "40px",
            height: "6px",
            background: "rgb(216,175,110)",
            margin: "0px auto 76px auto",
            [theme.breakpoints.down('xs')]: {
                margin: "0px auto 60px auto",
                "&.en": {
                    margin: "0px auto 40px auto",
                }
            }
        },
        "& .description": {
            margin: "0px auto",
            fontSize: "32px",
            lineHeight: "50px",
            fontWeight: "600",
            width: "fit-content",
            maxWidth: "750px",
            textAlign: "center",
            [theme.breakpoints.down('xs')]: {
                fontSize: "24px",
                "&.en": {
                    fontSize: "20px",
                    lineHeight: "40px"
                }
            }
        },
        "& .scroll-hint": {
            color: "#f5f5f5",
            alignItems: "center",
            position: "absolute",
            bottom: "40px",
            left: "50%",
            fontSize: "16px",
            fontWeight: "500",
            display: "flex",
            flexDirection: "column",
            transform: "translate(-50%,0%)",
            animation: "$scrollHintAnimation .4s infinite",
            animationDirection: 'alternate',
            "& img": {
                width: "23px",
                height: "14px",
                marginTop: "12px"
            }
        }
    },
    "@keyframes scrollHintAnimation": {
        "0%": {
            transform: 'translate(-50%,0)'
        },
        "100%": {
            transform: 'translate(-50%,-5px)'
        }
    },
    secondBlock: {
        padding: "86px 24px 70px 24px",
        backgroundSize: 'cover',
        backgroundPosition: "center",
        color: "#fff",
        "& .title": {
            fontSize: "28px",
            width: "fit-content",
            margin: "0px auto 70px auto",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            "& img": {
                width: "55px",
                height: "55px",
                marginRight: "10px",
                [theme.breakpoints.down('xs')]: {
                    margin: "0px 0px 12px 0px"
                }
            },
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                justifyContent: "center",
                flexDirection: "column",
                fontSize: "20px",
                margin: "0px auto 30px auto",
            }
        },
        "& .description": {
            fontSize: "16px",
            lineHeight: "32px",
            color: "rgba(255,255,255,0.6)",
            width: "fit-content",
            maxWidth: "800px",
            margin: "0px auto 70px auto",
            [theme.breakpoints.down('xs')]: {
                margin: "0px auto 30px auto",
            }
        },
        "& .strategy-block": {
            maxWidth: "600px",
            margin: "0px auto"
        },
        "& .strategy": {
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
        },
        "& .strategy-icon": {
            width: "100px",
            height: "100px",
            marginBottom: "12px"
        },
        "& .strategy-title": {
            fontSize: "16px",
            fontWeight: "bold",
            color: "#dab873",
            marginBottom: "12px",
            textAlign: "center"
        },
        "& .strategy-info": {
            fontSize: "16px",
            textAlign: "center",
            lineHeight: "24px",
            [theme.breakpoints.down('xs')]: {
                maxWidth: "140px"
            }
        }
    },
    thirdBlock: {
        padding: "86px 24px 70px 24px",
        background: `url(${ThirdBG}) , #001229`,
        backgroundSize: 'cover',
        backgroundPosition: "center",
        color: "#fff",
        "& .title": {
            fontSize: "28px",
            width: "fit-content",
            margin: "0px auto 70px auto",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            "& img": {
                width: "55px",
                height: "55px",
                marginRight: "10px",
                [theme.breakpoints.down('xs')]: {
                    margin: "0px 0px 12px 0px"
                }
            },
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                justifyContent: "center",
                flexDirection: "column",
                fontSize: "20px",
                margin: "0px auto 30px auto",
            }
        },
        "& .opportunity-block": {
            width: "100%",
            justifyContent: "space-between",
            maxWidth: "1300px",
            margin: "0px auto",
            [theme.breakpoints.down('xs')]: {
                justifyContent: "center",
            }
        },
        "& .opportunity": {
            maxWidth: "400px",
            display: "flex"
        },
        "& .opportunity-icon": {
            width: "20px",
            height: "20px",
            margin: "4px 20px 0px 0px"
        },
        "& .opportunity-title": {
            fontSize: "20px",
            lineHeight: "29px",
            fontWeight: "normal",
            [theme.breakpoints.down('md')]: {
                fontSize: "18px",
                lineHeight: "26px",
            },
            [theme.breakpoints.down('sm')]: {
                fontSize: "16px",
                lineHeight: "22px",
            },
            [theme.breakpoints.down('xs')]: {
                fontSize: "14px",
                lineHeight: "20px",
            }
        }
    },
    forthBlock: {
        padding: "86px 24px 140px 24px",
        background: `url(${ForthBG}) , #001229`,
        backgroundSize: 'cover',
        backgroundPosition: "center",
        color: "#001229",
        "& .title": {
            fontSize: "28px",
            width: "fit-content",
            margin: "0px auto 70px auto",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            "& img": {
                width: "55px",
                height: "55px",
                marginRight: "10px",
                [theme.breakpoints.down('xs')]: {
                    margin: "0px 0px 12px 0px"
                }
            },
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                justifyContent: "center",
                flexDirection: "column",
                fontSize: "20px",
                margin: "0px auto 30px auto",
            }
        },
        "& .content-block": {
            width: "100%",
            margin: "0px auto",
            maxWidth: "1100px",
            justifyContent: "space-between",
            [theme.breakpoints.down('md')]: {
                justifyContent: "space-evenly",
            }
        },
        "& .description": {
            maxWidth: "395px",
            fontWeight: "normal",
            opacity: "0.7",
            fontSize: "16px",
            color: "rgba(2,6,30,0.86)",
            lineHeight: "32px",
            [theme.breakpoints.down('sm')]: {
                marginBottom: "40px"
            }
        },
        "& .image-block": {
            width: '100%',
            maxWidth: "600px"
        },
        "& .slick-slider": {
            cursor: "pointer",
            "& li button:before": {
                opacity: "1",
                content: "''",
                backgroundSize: "cover",
                width: "10px",
                height: "10px",
                backgroundImage: `url(${rectangleGray})`
            },
            "& .slick-active button:before": {
                backgroundImage: `url(${rectangleGolden})`
            }
        },
        "& .swiper-slide": {
            cursor: "pointer"
        },
        "& .swiper-pagination-bullet": {
            opacity: "1",
            content: "''",
            backgroundSize: "cover",
            width: "10px",
            height: "10px",
            backgroundImage: `url(${rectangleGray})`,
            backgroundColor: 'transparent',
            "&.swiper-pagination-bullet-active": {
                backgroundImage: `url(${rectangleGolden})`
            }
        },
    },
    customBlock: {
        padding: "86px 24px 60px 24px",
        background: `#fff`,
        backgroundSize: 'cover',
        backgroundPosition: "center",
        color: "#001229",
        "& .title": {
            fontSize: "28px",
            width: "fit-content",
            margin: "0px auto 70px auto",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            "& img": {
                width: "55px",
                height: "55px",
                marginRight: "10px",
                [theme.breakpoints.down('xs')]: {
                    margin: "0px 0px 12px 0px"
                }
            },
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                justifyContent: "center",
                flexDirection: "column",
                fontSize: "20px",
                margin: "0px auto 30px auto",
            }
        },
        "& .content-block": {
            width: "100%",
            maxWidth: "680px",
            margin: "0px auto"
        },
        "& .text": {
            fontSize: "16px",
            color: "#001229",
            fontWeight: "normal",
            lineHeight: 1.5,
        },
        "& .caption": {
            textAlign: 'center',
            fontSize: "14px"
        },
        "& .image": {
            width: "100%",
            height: "auto"
        },
        "& .heading1": {
            fontSize: "30px",
            fontWeight: "700"
        },
        "& .heading2": {
            fontSize: "18px",
            fontWeight: "500"
        },
        '& .blockQuote': {
            fontStyle: "italic",
            position: "relative",
            textAlign: "center",
            padding: "20px 0px",
            fontSize: "21px",
            opacity: "0.65",
            lineHeight: "1.48",
            "&::before": {
                display: "inline-block",
                marginRight: "16px",
                content: '"“"',
                fontSize: "21px",

            },
            "&::after": {
                display: "inline-block",
                marginLeft: "16px",
                content: '"”"',
                fontSize: "21px",
            }
        },
    },
    otherBlock: {
        padding: "86px 24px 20px 24px",
        background: `#fff`,
        backgroundSize: 'cover',
        backgroundPosition: "center",
        color: "#001229",
        "& .title": {
            fontSize: "28px",
            width: "fit-content",
            margin: "0px auto 70px auto",
            display: "flex",
            alignItems: "center",
            fontWeight: "bold",
            "& img": {
                width: "55px",
                height: "55px",
                marginRight: "10px",
                [theme.breakpoints.down('xs')]: {
                    margin: "0px 0px 12px 0px"
                }
            },
            [theme.breakpoints.down('xs')]: {
                textAlign: "center",
                justifyContent: "center",
                flexDirection: "column",
                fontSize: "20px",
                margin: "0px auto 30px auto",
            }
        },
        "& .otherTitle": {
            margin: "0px auto 32px auto",
        },
        "& .title-divider": {
            width: '100px',
            height: '2px',
            backgroundColor: '#dab873',
            marginBottom: "32px"
        },
        "& .info": {
            fontSize: "16px",
            maxWidth: "680px",
            margin: "0px auto 30px auto"
        },
        "& .news-block, .project-block": {
            width: "100%",
            maxWidth: "1024px",
            margin: "0px auto 160px auto"
        },
        "& .news-card, .project-card": {
            cursor: "pointer",
            "&:hover": {
                "& .news-picture, .project-picture": {
                    transform: "scale(1.1)",
                }
            }
        },
        "& .news-title": {
            color: "#001229",
            fontSize: "20px",
            fontWeight: "500",
            marginTop: "12px",
            minHeight: "80px",
            [theme.breakpoints.down('sm')]: {
                fontSize: "16px",
                minHeight: "60px",
            }
        },
        "& .picture-block": {
            width: "100%",
            height: "200px",
            overflow: "hidden"
        },
        "& .news-picture, .project-picture": {
            width: "100%",
            height: "100%",
            transform: "scale(1)",
            transition: "0.3s"
        },
        "& .project-title": {
            color: "#001229",
            marginTop: "12px",
            padding: "6px 16px",
            opacity: "0.5",
            fontSize: "20px",
            fontWeight: "bold",
            [theme.breakpoints.down('sm')]: {
                fontSize: "16px",
            }
        },
        "& .project-subtitle": {
            color: "#001229",
            padding: "8px 16px",
            fontSize: "20px",
            fontWeight: "bold",
            [theme.breakpoints.down('sm')]: {
                fontSize: "16px",
            }
        }
    }
}))

const EmpowerDetails = (props: any) => {
    const classes = useStyles()
    const dispatch = useDispatch()
    const empowerSelector = useSelector((state: any) => state.leadbest.empower);
    const global = useSelector((state: any) => state.global);
    const isEnglish = global.locale == 'en_us'
    const { id, isMobileScreen, intl } = props
    const history = useHistory()

    const languagesIndex = languages[global.locale].id;
    const empowerDetails = empowerSelector.empowerDetails

    const correspondingLanguage = (translations: any) => {
        if (!translations) return;
        const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
        return translations.find((item: any) => item.languages_code.code == language)
    }

    const translationData = (translations: any) => {
        return translations.find((item: any) => item.languages_code.code.toLowerCase() == global.locale.replace('_', '-').toLowerCase())
    }
    const langData = correspondingLanguage(empowerDetails.data.translations)

    useEffect(() => {
        if (empowerDetails.loading) return;
        dispatch(EmpowerActions.getEmpowerdetailsRequest({ params: {}, id }));
    }, [id])

    return (
        <div className={classes.root}>
            {empowerDetails.loading &&
                <Skeleton animation="wave" variant="rect" height="100vh" width="100vw" style={{ marginBottom: 300 }} />
            }

            {/* --- SEO --- */}
            {!empowerDetails.loading && empowerDetails.loaded &&
                <Helmet>
                    {/* 先調整成抓中文，之後Lb-tool的Router升級後，再改成抓當下的語系 */}
                    <title>{translationData(empowerDetails.data.translations)?.meta_title || translationData(empowerDetails.data.translations)?.project_name}</title>
                    <meta name="description" content={translationData(empowerDetails.data.translations)?.meta_description || translationData(empowerDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
                    <meta property="og:url" content={`https://www.leadbestgroup.com${history.location.pathname}`} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content={translationData(empowerDetails.data.translations)?.meta_title || translationData(empowerDetails.data.translations)?.project_name} />
                    <meta property="og:description" content={translationData(empowerDetails.data.translations)?.meta_description || translationData(empowerDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
                    <meta property="og:image" content={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${empowerDetails.data.cover?.id}&fit=cover&width=600&height=400`} />
                    <meta property="fb:app_id" content={`${window.Config.FB_APP_ID}`} />
                    {/* <title>{correspondingLanguage(newsDetails.data.translations)?.project_name}</title>
                    <meta name="description" content={correspondingLanguage(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
                    <meta property="og:url" content={`https://www.leadbestgroup.com${history.location.pathname}`} />
                    <meta property="og:type" content="article" />
                    <meta property="og:title" content={correspondingLanguage(newsDetails.data.translations)?.title} />
                    <meta property="og:description" content={correspondingLanguage(newsDetails.data.translations)?.contents.find((item: any) => item.type == "TEXT")?.content} />
                    <meta property="og:image" content={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${newsDetails.data.cover?.id}&fit=cover&width=600&height=400`} /> */}
                </Helmet>
            }

            {!empowerDetails.loading && empowerDetails.loaded &&
                <>
                    <FirstBlock intl={intl} data={empowerDetails.data} langData={langData} isEnglish={isEnglish} />
                    <SecondBlock intl={intl} data={empowerDetails.data} langData={langData} isEnglish={isEnglish} />
                    <ThirdBlock intl={intl} data={empowerDetails.data} langData={langData} isEnglish={isEnglish} />
                    <ForthBlock intl={intl} data={empowerDetails.data} langData={langData} isEnglish={isEnglish} />
                    <CustomBlock intl={intl} data={empowerDetails.data} langData={langData} isMobileScreen={isMobileScreen} isEnglish={isEnglish} />
                    <OtherBlock intl={intl} data={empowerDetails.data} langData={langData} languagesIndex={languagesIndex} isEnglish={isEnglish} />
                </>
            }
        </div>
    )
}
const FirstBlock = (props: any) => {
    const classes = useStyles()
    const { data, langData, intl, isEnglish } = props

    return (
        <div className={classes.firstBlock} style={{ backgroundImage: `url(${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${data.header_image.id}?fit=cover&width=1900&height=1200)` }}>
            <div className="time">{`${moment(data.date_start).format('YYYY.MM.DD')} - ${data.date_end ? moment(data.date_end).format('YYYY.MM.DD') : 'now'}`}</div>
            <div className={clsx("title", isEnglish && "en")}>{langData.project_name}</div>
            <div className={clsx("divider", isEnglish && "en")} />
            <div className={clsx("description", isEnglish && "en")}>{langData.description}</div>
            <div className="scroll-hint">
                {intl.formatMessage({ id: "system.scrollHint" })}
                <img src={ArrowBottom} alt="" />
            </div>
        </div>
    )
}
const SecondBlock = (props: any) => {
    const classes = useStyles()
    const { data, langData, intl, isEnglish } = props
    return (
        <div className={classes.secondBlock} style={{ backgroundImage: `url(${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${data.digital_strategy_background.id}?fit=cover&width=1900&height=700)` }}>
            <div className="title">
                {/* <img src={Mascot} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.secondBlock.title" })}
            </div>
            <div className="description">
                {langData.digital_strategy_desc}
            </div>
            <Grid container className="strategy-block" spacing={3}>
                {langData.digital_strategies.map((item: any, index: number) =>
                    <Grid item xs={12} sm={4} md={4} key={index} className="strategy">
                        <img className="strategy-icon" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.icon.id}`} alt="" />
                        <div className="strategy-title">{item.strategy}</div>
                        <div className="strategy-info">{item.desc}</div>
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
const ThirdBlock = (props: any) => {
    const classes = useStyles()
    const { data, langData, intl } = props

    return (
        <div className={classes.thirdBlock}>
            <div className="title">
                {/* <img src={Mascot} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.thirdBlock.title" })}
            </div>
            <Grid container className="opportunity-block" spacing={3}>
                {langData.opportunities.map((item: any, index: number) =>
                    <Grid item xs={12} sm={4} md={4} key={index} className="opportunity">
                        <img className="opportunity-icon" src={Magnifier} alt="" />
                        <div className="opportunity-title">{item.opportunity}</div>
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
const ForthBlock = (props: any) => {
    const classes = useStyles()
    const lgIns: any = useRef({});
    const { data, langData, intl } = props
    const global = useSelector((state: any) => state.global);

    const settings = {
        dots: true,
        infinite: false,
        arrows: false,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
    };

    const onInit = (lg: any) => {
        lgIns.current = lg;
    }

    const genItem = () => {
        let items: any = [];
        getEmpowermentImages().map((item: any) => {
            items.push({
                src: `${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.directus_files_id.id}?fit=cover`,
                thumb: `${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.directus_files_id.id}?fit=cover&width=600&height=400`,
            });
        });
        
        return items;
    }

    const slideClick = (index: any) => {
        lgIns.current.instance.openGallery(index);
    }

    const translationData = (translations: any) => {
        return translations.find((item: any) => item.languages_code.code.toLowerCase() == global.locale.replace('_', '-').toLowerCase())
    }

    const getEmpowermentImages = () => {
        if (translationData(data.translations).digital_empowerment_practice_images.length) {
            return translationData(data.translations).digital_empowerment_practice_images;
        }
        else {
            return data.digital_empowerment_practice_images;
        }
    }

    return (
        <div className={classes.forthBlock}>
            <div className="title">
                {/* <img src={MascotBlack} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.forthBlock.title" })}
            </div>
            <Grid className="content-block" container>
                <Grid item xs={12} sm={12} md={5} className="description">
                    {langData.digital_empowerment_practice_desc}
                </Grid>
                <Grid item xs={12} sm={12} md={7} className="image-block">
                    <LightGallery
                        speed={500}
                        plugins={[lgThumbnail, lgZoom]}
                        dynamic={true}
                        dynamicEl={genItem()}
                        onInit={onInit}
                    >
                    </LightGallery>

                    <Swiper
                        modules={[Pagination, EffectCreative]}
                        spaceBetween={50}
                        slidesPerView={1}
                        pagination={{ clickable: true }}
                        onSlideChange={() => console.log('slide change')}
                        onSwiper={(swiper) => console.log(swiper)}
                        effect={'creative'}
                        creativeEffect={{
                            prev: {
                                shadow: true,
                                translate: [0, 0, -400],
                            },
                            next: {
                                translate: ['100%', 0, 0],
                            },
                        }}
                    >
                        {
                            getEmpowermentImages().map((item: any, index: number) =>
                                <SwiperSlide><img width={'100%'} src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.directus_files_id.id}?fit=cover&width=600&height=400`} alt="digital-empowerment-practice-images" key={index} onClick={() => {
                                    slideClick(index);
                                }} /></SwiperSlide>

                            )
                        }
                    </Swiper>
                    
                    
                    {/* <Slider {...settings} >
                        <Box>
                        <img src="https://api.leadbestgroup.com/assets/e61446e3-3287-4bb0-b08d-15fd3999ad75?fit=cover&amp;width=600&amp;height=400" alt="digital-empowerment-practice-images" onClick={() => {
                            slideClick(0);
                        }} />
                        </Box>
                        <Box>
                        <img src="https://api.leadbestgroup.com/assets/185ec016-d206-44f5-b081-e94f382da159?fit=cover&amp;width=600&amp;height=400" alt="digital-empowerment-practice-images" onClick={() => {
                            slideClick(1);
                        }} />
                        </Box>

                        {data.digital_empowerment_practice_images.map((item: any, index: number) =>
                            <img src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.directus_files_id.id}?fit=cover&width=600&height=400`} alt="digital-empowerment-practice-images" key={index} onClick={() => {
                                slideClick(index);
                            }} />
                        )}
                    </Slider> */}
                    
                </Grid>
            </Grid>
        </div>
    )
}
const CustomBlock = (props: any) => {
    const classes = useStyles()
    const { data, langData, isMobileScreen, intl } = props

    const innerTextLink = (content: any) => {
        const rule: RegExp = /&link;(\S*)&link;/
        const substr: any = content.match(rule);
        if (substr == null) return content;
        const marchString = substr['0']
        const linkData = JSON.parse(substr['1'])
        return content.replace(marchString, `<a href=${linkData[1]} target="_blank" rel="noreferrer noopener">${linkData[0]}</a>`)
    }

    return (
        <div className={classes.customBlock}>
            <div className="title">
                {/* <img src={MascotBlack} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.customBlock.title" })}
            </div>
            <div className="content-block">
                {langData.contents.map((item: any, index: number) => {
                    switch (item.type) {
                        case 'TEXT':
                            return <Box mb={4} className="text" key={index} dangerouslySetInnerHTML={{ __html: innerTextLink(item.content) }} />
                        case 'IMAGE':
                            return <Box mb={2} key={index}><figure style={{ margin: 0 }}><img className="image" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.image?.id}`} alt={item.content} /></figure></Box>
                        case 'YOUTUBE_VIDEO':
                            return <Box mb={4} className="youtube" key={index}><iframe width="100%" height={isMobileScreen && '185px' || '492px'} src={`https://www.youtube.com/embed/${item.content.split('?v=')[1]}`} frameBorder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowFullScreen /></Box>
                        case 'LINK':
                            return <Box mb={4} className="link" key={index}>{intl.formatMessage({ id: "system.newsSource" })}<a href={item.content} target="_blank" rel="noreferrer noopener">{item.content}</a></Box>
                        case 'HORIZONTAL_LINE':
                            return <Box mb={4} className="divider" key={index} />
                        case 'CAPTION':
                            return <Box mb={4} className="caption" key={index}>{item.content}</Box>
                        case 'LINE_BREAK':
                            return <Box mb={Number(item.content)} className="lineBreak" key={index} />
                        case 'BLOCK_QUOTE':
                            return <Box mb={4} className="blockQuote" key={index}>{item.content}</Box>
                        case 'HEADING_1':
                            return <Box mb={2} className="heading1" key={index}>{item.content}</Box>
                        case 'HEADING_2':
                            return <Box mb={2} className="heading2" key={index}>{item.content}</Box>

                        default:
                            return null;
                    }
                })}
            </div>
        </div>)
}
const OtherBlock = (props: any) => {
    const classes = useStyles()
    const { data, langData, languagesIndex, intl } = props
    const history = useHistory()
    const correspondingLanguage = (translations: any, propertyName: string) => {
        if (!translations) return;
        const language = languagesIndex == 0 ? 'zh-TW' : 'en-US'
        return translations.find((item: any) => item[propertyName] == language)
    }

    return (
        <div className={classes.otherBlock}>
            <div className="title otherTitle">
                {/* <img src={MascotBlack} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.otherBlock.relativedNews.title" })}
            </div>
            <Box display="flex" justifyContent="center" alignItems="center">
                <div className="title-divider"></div>
            </Box>
            {!!langData?.related_news_desc?.length && <div className="info">{langData.related_news_desc}</div>}
            <Grid container spacing={3} className="news-block">
                {data.related_news.map((item: any, index: number) =>
                    <Grid xs={12} sm={6} md={4} key={index} item className="news-card" >
                        <Link to={`/news/${item.news_id.id}`}>
                            <div className="picture-block">
                                <img className="news-picture" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.news_id.cover.id}?fit=cover&width=320&height=200`} alt="news-picture" />
                            </div>
                            <div className="news-title">{correspondingLanguage(item.news_id.translations, "languages_id")?.title}</div>
                        </Link>
                    </Grid>
                )}
            </Grid>
            <div className="title otherTitle">
                {/* <img src={MascotBlack} alt="" /> */}
                {intl.formatMessage({ id: "empowerDetails.otherBlock.relativedEmpower.title" })}
            </div>
            <Box display="flex" justifyContent="center" alignItems="center">
                <div className="title-divider"></div>
            </Box>
            <Grid container spacing={3} className="project-block">
                {data.related_projects.map((item: any, index: number) =>
                    <Grid xs={12} sm={6} md={4} key={index} item className="project-card" >
                        <Link to={`/empower/${item.related_projects_id.id}`}>
                            <div className="picture-block">
                                <img className="project-picture" src={`${window.Config.LEADBEST_OFFICIAL_WEBSITE_API_HOST}/assets/${item.related_projects_id.cover.id}?fit=cover&width=320&height=200`} alt="news-picture" />
                            </div>
                            <div className="project-title">{correspondingLanguage(item.related_projects_id.translations, "languages_code")?.customer}</div>
                            <div className="project-subtitle">{correspondingLanguage(item.related_projects_id.translations, "languages_code")?.description}</div>
                        </Link>
                    </Grid>
                )}
            </Grid>
        </div>
    )
}
export default injectIntl(EmpowerDetails);